import React from 'react'
import AliceCarousel from 'react-alice-carousel';

import "react-alice-carousel/lib/alice-carousel.css";
import RG_logo from "./Img/RG_logo.png"
import image2 from "./Img/download.jpg"
import image3 from "./Img/download (1).jpg"
import tata from "./Img/tata.png"
import gg from "./Img/goldgym.png"

const Home = () => {
  return (
    <div>
  {/* //   <div class="w3-content" style={{width:"2000px",margin:"46px"}}>
    
  //   <div class=" w3-display-container w3-center">
  //   <img src={RG_logo} style={{width:"100%" }}/>
  //   <div class="w3-display-bottommiddle w3-container w3-text-white w3-padding-32 w3-hide-small">
  //     <h3>Los Angeles</h3>
  //     <p><b>We had the best time playing at Venice Beach!</b></p>   
  //   </div>
  // </div>
  // <div class="mySlides w3-display-container w3-center">
  //   <img src={image2} style={{width:"100%" }}/>
  //   <div class="w3-display-bottommiddle w3-container w3-text-white w3-padding-32 w3-hide-small">
  //     <h3>New York</h3>
  //     <p><b>The atmosphere in New York is lorem ipsum.</b></p>    
  //   </div>
  // </div>
  // <div class="mySlides w3-display-container w3-center">
  //   <img src={image3} style={{width:"100%" }}/>
  //   <div class="w3-display-bottommiddle w3-container w3-text-white w3-padding-32 w3-hide-small">
  //     <h3>Chicago</h3>
  //     <p><b>Thank you, Chicago - A night we won't forget.</b></p>    
  //   </div>
  // </div> */}

    <div> 
    <AliceCarousel autoPlay autoPlayInterval="2000" className="sliders" infinite="True" disableButtonsControls="True">
      <p><img src={RG_logo} className="sliderimg"/></p>
      <p><img src={image2} className="sliderimg"/></p>
      <p><img src={image3} className="sliderimg"/></p>

    </AliceCarousel>
    <div>
    <div class="w3-row w3-center w3-dark-grey w3-padding-16">
  <div class="w3-quarter w3-section">
    <span class="w3-xlarge">20+</span><br/>
    Partners
  </div>
  <div class="w3-quarter w3-section">
    <span class="w3-xlarge">50+</span><br/>
    Projects Done
  </div>
  <div class="w3-quarter w3-section">
    <span class="w3-xlarge">100+</span><br/>
    Happy Clients
  </div>
  <div class="w3-quarter w3-section">
    <span class="w3-xlarge">200+</span><br/>
    Meetings
  </div>
</div>
    </div>
    <div>
    <div class="w3-content w3-container w3-padding-64" id="portfolio">
  <h3 class="w3-center">Our clients</h3>
  <p class="w3-center"><em>Here are some of my latest lorem work ipsum tipsum.<br/> Click on the images to make them bigger</em></p><br/>

  <div class="w3-row-padding w3-center">
    <div class="w3-col m3">
      <img src={tata} style={{width:"100%" }} onclick="onClick()" class="w3-hover-opacity" alt="The mist over the mountains"/>
    </div>

    <div class="w3-col m3">
    <img src={tata} style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="Coffee beans"/>
    </div>

    <div class="w3-col m3">
    <img src={tata} style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="Bear closeup"/>
    </div>

    <div class="w3-col m3">
    <img src={tata} style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="Quiet ocean"/>
    </div>
  </div>

  <div class="w3-row-padding w3-center w3-section">
    <div class="w3-col m3">
      <img src={gg} style={{width:"100%" }} onclick="This is the ood service" class="w3-hover-opacity" alt="The mist"/>
    </div>

    <div class="w3-col m3">
    <img src={gg}  style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="My beloved typewriter"/>
    </div>

    <div class="w3-col m3">
    <img src={gg}  style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="Empty ghost train"/>
    </div>

    <div class="w3-col m3">
    <img src={gg}  style={{width:"100%" }} onclick="onClick(this)" class="w3-hover-opacity" alt="Sailing"/>
    </div>
  </div>
</div>
    </div>
    
    </div> 
    </div>
  )
}

export default Home